const m = [
  62,
  -1,
  -1,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  -1,
  -1,
  -1,
  -1,
  63,
  -1,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51
], D = 1, n = typeof BigInt < "u" ? BigInt : Number;
function E(r) {
  const e = r.charCodeAt(0);
  return m[e - 45];
}
function I(r) {
  let e = n(0), t = n(0);
  const o = [];
  if (r.split("").forEach((c) => {
    const s = n(E(c));
    e |= (s & n(31)) << t, (s & n(32)) === n(0) ? (o.push(e), e = n(0), t = n(0)) : t += n(5);
  }), t > 0)
    throw new Error("Invalid encoding");
  return o;
}
function L(r, e) {
  if (+r.toString() !== D)
    throw new Error("Invalid format version");
  const t = +e.toString(), o = t & 15, c = t >> 4 & 7, s = t >> 7 & 15;
  return { precision: o, thirdDim: c, thirdDimPrecision: s };
}
function u(r) {
  let e = r;
  return e & n(1) && (e = ~e), e >>= n(1), +e.toString();
}
function y(r) {
  const e = I(r), t = L(e[0], e[1]), o = 10 ** t.precision, c = 10 ** t.thirdDimPrecision, { thirdDim: s } = t;
  let d = 0, a = 0, f = 0;
  const l = [];
  let i = 2;
  for (; i < e.length; ) {
    const h = u(e[i]) / o, g = u(e[i + 1]) / o;
    if (d += h, a += g, s) {
      const p = u(e[i + 2]) / c;
      f += p, l.push([a, d, f]), i += 3;
    } else
      l.push([a, d]), i += 2;
  }
  if (i !== e.length)
    throw new Error("Invalid encoding. Premature ending reached");
  return {
    type: "FeatureCollection",
    features: [
      {
        id: "route",
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: l
        }
      }
    ]
  };
}
export {
  y as decodePolyline
};
